import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material'
import { useState } from 'react'
import { useDownloadModelLazyQuery } from '../../../apollo/configurator/queries/DownloadModel.generated'
import { useFlushActionsCacheMutation } from '../../../apollo/personalization/mutations/FlushActionsCache.generated'
import {
    exportData,
    handleConfirm as handleDownloadConfirm
} from '../../../components/modelManager/molecules/manager/helpers/ImportExportModel'

interface DownloadModelDialogProps {
    open: boolean
    modelId: string
    onClose: () => void
}

export const DownloadModelDialog: React.FC<DownloadModelDialogProps> = ({
    open,
    modelId,
    onClose
}) => {
    const [inclPresets, setInclPresets] = useState(false)

    const [downloadModel, { loading: downloading }] = useDownloadModelLazyQuery({
        onCompleted: (data) => {
            exportData({
                model: JSON.parse(data.configuratorExportJSONModel?.model ?? '[]'),
                presets: JSON.parse(data.configuratorExportJSONModel?.presets ?? '[]')
            })
            handleClose()
        },
        fetchPolicy: 'network-only'
    })

    const [flushActionsCache] = useFlushActionsCacheMutation()

    const handleClose = () => {
        setInclPresets(false)
        onClose()
    }

    const handleConfirm = () => {
        handleDownloadConfirm(downloadModel, +modelId, inclPresets)
        flushActionsCache()
        // Dialog will be closed in the downloadModel onCompleted callback
    }
    return (
        <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            aria-labelledby="download-dialog-title"
            aria-describedby="download-dialog-description"
        >
            <DialogTitle id="download-dialog-title">
                Export the model to a file and Download.
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="download-dialog-description">
                    <Checkbox
                        checked={inclPresets}
                        style={{ top: '-1px', position: 'relative' }}
                        onChange={(evt, val) => {
                            setInclPresets(val)
                        }}
                    />{' '}
                    Include Presets?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="primary"
                    disabled={downloading}
                >
                    {downloading ? 'Exporting...' : 'Export'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
